import React from 'react';
import ProtectedRoute from '../components/ProtectedRoute';
import DashboardLayout from '../components/DashboardLayout';
import VideoUpload from '../components/VideoUpload';
import VideoList from '../components/VideoList';

const Admin = () => {
  return (
    <ProtectedRoute roles={['ADMIN']}>
      <DashboardLayout title="Admin Dashboard" roles={['ADMIN']}>
        <div className="space-y-8">
          {/* Video Upload Section */}
          <VideoUpload />

          {/* Video Management Section */}
          <VideoList />
        </div>
      </DashboardLayout>
    </ProtectedRoute>
  );
};

export default Admin;
